import React, { FC, memo } from 'react'

import { ToggleProps } from '@/types/componentsPropsTypes'

import { ToggleEl, ToggleWrapper } from './styles'

const ToggleRaw: FC<ToggleProps> = ({
  checked = false,
  onChange,
  id,
  focusId,
  disabled = false,
  small = false,
}) => {
  const toggleChecked = () => {
    !disabled && onChange && onChange(id)
  }

  return (
    <ToggleWrapper $small={small}>
      <ToggleEl
        focusId={`Toggle-${focusId || id}`}
        $isChecked={checked}
        $disabled={disabled}
        $small={small}
        onSelected={toggleChecked}
      />
    </ToggleWrapper>
  )
}
export const Toggle = memo(ToggleRaw)
